import Glide from '@glidejs/glide'
import getLabel from 'foundation/js/getLabel'
import { onMounted, ref } from 'vue'

const unifyCardHeight = function (root) {
    root.value.querySelectorAll('.glide__slide').forEach((slide) => {
        slide.style.height = `auto`
    })
}

export default {
    name: 'InfoCarousel',
    setup() {
        const root = ref(null)
        const options = {
            type: 'slider',
            rewind: false,
            startAt: 0,
            perView: 1,
            gap: 32,
            peek: {
                after: 150,
                before: 0
            },
            breakpoints: {
                768: {
                    gap: 18,
                    peek: {
                        after: 54,
                        before: 0
                    }
                }
            }
        }

        onMounted(() => {
            const glide = new Glide(root.value.parentNode, options)

            glide.mount()
            unifyCardHeight(root)

            root.value.parentNode.querySelectorAll('a').forEach((a) =>
                a.addEventListener('focus', function (event) {
                    var el = event.target
                    while (el && !el.hasAttribute('data-index')) {
                        el = el.parentNode
                    }

                    var index = el?.attributes['data-index']?.value
                    if (index) glide.go('=' + index)
                })
            )
        })

        return {
            getLabel,
            root
        }
    }
}
